<i
  [class]="this.customIcon() + ' ms-1'"
  [tooltip]="content"
  containerClass="hint"
  [tooltipAnimation]="true"
  [tooltipFadeDuration]="1"
  [placement]="'right'"
  container="body"
  [style.color]="this.customColor()"
></i>
<ng-template #content>
  <ng-content></ng-content>
</ng-template>